// extracted by mini-css-extract-plugin
export default {"success-message-box":"message_success-message-box__9p-c2","error-message-box":"message_error-message-box__SJvTc"};